const servicesData = [
  {
    key: "distribution",
    title: "Distribution",
    whyChoose: {
      heading: "Why Choose Our Distribution Services",
      points: [
        "Ultra-reliable global distribution network infrastructure.",
        "Multiple options: fiber, IP, satellite, OTT, and hybrid solutions.",
        "Flexible delivery across broadcast, OTT, and multi-platform destinations.",
        "Proactive service assurance, 24/7 technical support, and SLAs.",
      ],
      image: "/dis.png",
    },
    sections: [
      {
        heading: "Distribution Services",
        content:
          "At Video Media, we ensure your content is delivered to reach its intended audience, globally and reliably, across whatever transport suits it best. Be it IP, fiber, or OTT networks, our distribution services are designed for maximum reach, reliability, and quality.",
      },
      {
        heading: "Fiber & IP Distribution Networks",
        content:
          "We manage global fiber and IP backbone networks for major broadcast hubs, ensuring low-latency, high-capacity delivery of your content. Our infrastructure is engineered to support real-time, multi-region distribution, with excellent speed, security, and performance.",
      },
      {
        heading: "Broadcast Contribution Services",
        content:
          "From remote locations to central studios, we provide acquisition of your live feeds and remote integration. Our solutions cover SD/HD/4K signal acquisition and global distribution for all feeds—delivering your content where and when you need it, securely and reliably, with low-latency.",
      },
      {
        heading: "Satellite Distribution",
        content:
          "We provide global satellite uplinks, capacity, and first/last-mile solutions for broadcasters, media networks, and streaming platforms. With extensive experience across CEE, MEA, and LATC markets, our team delivers seamless and reliable satellite distribution.",
      },
      {
        heading: "OTT & Streaming Distribution",
        content:
          "We deliver video and playout streams to OTT partners and audiences directly via OTT and streaming services. Our workflows support adaptive bitrate (ABR) packaging, CDN integration, and multi-device delivery—ensuring your content reaches viewers everywhere.",
      },
      {
        heading: "Remote Production",
        content:
          "Enable remote workflows and production for your content to be present remotely, reducing on-site costs while maintaining quality. By combining our contribution, cloud integration, and remote switching, we help you save resources and maximize efficiency.",
      },
    ],
  },
  {
    key: "playout",
    title: "Playout Services",
    whyChoose: {
      heading: "Why Choose Our Playout Services",
      points: [
        "Support for all formats (SD/HD/UHD/4K) with global distribution.",
        "Cloud-first approach for flexibility and cost efficiency.",
        "Deep expertise in multi-platform and multi-region delivery.",
        "Compliance and monitoring built into every workflow.",
        "24/7 managed service with a dedicated operations team.",
      ],
      image: "/playout.png", // Replace with actual image path if different
    },
    sections: [
      {
        heading: "Playout Services",
        content:
          "At Video Vision Media, we deliver seamless, flexible, and broadcast-grade playout services designed for today’s multi-platform world. From traditional linear channels to cloud-native workflows, our solutions ensure your content is always on-air, always compliant, and always reaching the right audience.",
      },
      {
        heading: "Channel Playout (SD/HD/UHD/4K)",
        content:
          "We provide carrier-grade playout for linear TV channels, supporting all formats from SD to UHD/4K. Our infrastructure ensures frame-accurate scheduling, seamless switching, and uninterrupted delivery for broadcasters worldwide.",
      },
      {
        heading: "Cloud / Virtualized Playout",
        content:
          "Our cloud-native playout solutions give broadcasters the flexibility to launch, scale, and manage channels with global distribution. Highly resilient cloud workflows bring agility, redundancy, and cost efficiency, all delivered via our 24/7 support and monitoring.",
      },
      {
        heading: "Multi-Platform Delivery",
        content:
          "Your content seamlessly reaches audiences wherever they watch—from satellite and cable operators to OTT, IPTV, and streaming platforms. Our platform delivers workflows and simultaneous output to all destinations, including digital feeds and VOD services.",
      },
      {
        heading: "Content Compliance & Monitoring",
        content:
          "We provide end-to-end compliance and monitoring for all playout, including QC, subtitling, captioning, loudness, branding, and regulatory requirements with automated logging. Our monitoring systems guarantee regulatory adherence and broadcast-grade reliability.",
      },
      {
        heading: "End-to-End Managed Services",
        content:
          "We offer full-service playout solutions, including content acquisition, encoding, playout, and distribution. Our managed services ensure your content is always on-air, always compliant, and always reaching the right audience.",
      },
    ],
  },
  {
    key: "creative",
    title: "Creative Services",
    whyChoose: {
      heading: "Why Choose Our Creative Services",
      points: [
        "Proven experience in live sports, entertainment, and broadcast channels.",
        "End-to-end creative: from concept to on-air delivery.",
        "Fast-turnaround workflows for digital and digital-first platforms.",
        "Global-ready: multilingual, multi-format, and culturally adapted solutions.",
        "Integrated with our playout and distribution services for seamless delivery.",
      ],
      image: "/creative.png", // Use the actual image path if different
    },
    sections: [
      {
        heading: "Creative Services",
        content:
          "At Video Vision Media, we believe great content isn’t just about delivery—it’s about engagement and impact. Our creative services combine storytelling, design, and technical expertise to help broadcasters, brands, and event organizers captivate audiences across every screen.",
      },
      {
        heading: "Digital and Live Highlights Creation",
        content:
          "From sports to live events, we create fast-turnaround digital and broadcast highlights that keep viewers engaged in real time. Our teams specialize in live clipping, editing, and packaging, optimized for TV, OTT, and social platforms.",
      },
      {
        heading: "Graphics & Motion Design",
        content:
          "We design dynamic broadcast graphics, motion design, and on air branding packages that elevate your channel or program. From score bugs to lower thirds and animation, our creative ensures your content stands out with visual excellence and technical precision.",
      },
      {
        heading: "Content Localisation & Versioning",
        content:
          "We adapt content for multiple languages, regions, and formats. From subtitling and dubbing to cultural adaptation and versioning, we make sure your programming is relevant, compliant, and ready for global distribution.",
      },
      {
        heading: "Promos & Creative Packaging",
        content:
          "We develop promotional campaigns, channel IDs, trailers, and brand packaging that bring your content to life. Our creative and editorial packaging makes your offer live eye-catching, on-brand assets that are ready for potential on-air, digital, and social use.",
      },
      {
        heading: "Studio Support",
        content:
          "We provide on-site and remote creative support for live productions, including graphics operations, highlight editing, and technical direction. Our experts become an extension of your team, ensuring flawless execution through every show and event.",
      },
    ],
  },
  {
    key: "cloud",
    title: "Cloud Services",
    whyChoose: {
      heading: "Why Choose Our Cloud Services",
      points: [
        "99.99% uptime with 24/7 network monitoring.",
        "Access to global satellite, fiber, and IP infrastructure.",
        "Proven expertise in sports, live events, and broadcast networks.",
        "Flexible delivery across broadcast, OTT, and hybrid platforms.",
        "End-to-end service — from encoding to last-mile distribution.",
      ],
      image: "/cloud.png", // Replace with actual image path if different
    },
    sections: [
      {
        heading: "Cloud Services",
        content:
          "At Video Vision Media, we bring the power, flexibility, and scalability of the cloud to broadcasters, operators, and enterprises. Whether you’re migrating workflows, launching new platforms, or building redundancy, our cloud services deliver agility without compromise.",
      },
      {
        heading: "Cloud Connect Services",
        content:
          "We provide direct, high-performance connectivity to major cloud platforms (AWS, Azure, GCP). Our secure links ensure low-latency, reliable transfer of media and data, enabling smooth integration between broadcast infrastructure and the cloud.",
      },
      {
        heading: "Hybrid & Multi-Cloud Integration",
        content:
          "Our solutions combine the best of on-premise and cloud environments, giving you flexibility, scalability, and resilience. With multi-cloud integration, we design workflows that optimize costs, avoid vendor lock-in, and ensure redundancy across providers.",
      },
      {
        heading: "Cloud-Based Media Processing",
        content:
          "We deliver scalable media workflows in the cloud, including transcoding, encoding, adaptive bitrate (ABR) packaging, and QC. Whether for live or on-demand, our cloud processing ensures your media is ready for distribution across broadcast, OTT, and digital platforms.",
      },
      {
        heading: "Cloud Storage & Archiving",
        content:
          "Our secure, scalable storage solutions give you instant access to media assets while ensuring long-term protection. We provide hybrid archiving or all-cloud options, helping you streamline workflows, allowing you to reduce infrastructure costs while safeguarding your content.",
      },
    ],
  },
  {
    key: "satellite-iot",
    title: "Satellite & IoT Services",
    whyChoose: {
      heading: "Why Choose Our Satellite & IoT Services",
      points: [
        "Access to global satellite constellations (LEO, MEO, GEO).",
        "Enterprise-grade IoT integration across multiple industries.",
        "Seamless connectivity for remote, maritime, and urban locations.",
        "Proven track record with governments, enterprises, and telecoms.",
        "End-to-end support from device management to analytics.",
      ],
      image: "/satellite.png", // Replace with actual image path if different
    },
    sections: [
      {
        heading: "Satellite & IoT Services",
        content:
          "At Video Vision Media, we deliver connectivity and intelligence to the most remote and challenging environments. Through advanced satellite networks and IoT solutions, we help enterprises, broadcasters, and service providers stay connected, automate, and make smarter decisions anywhere in the world.",
      },
      {
        heading: "VSAT / LEO / MEO / GEO Connectivity",
        content:
          "We design and manage satellite network solutions across all orbital classes—from traditional GEO to low-latency LEO constellations. Our VSAT networks power broadcast, broadband, video, and data services to support media, industry, and government operations globally.",
      },
      {
        heading: "Broadband-Over-Satellite",
        content:
          "We deliver high-speed internet and satellite, ensuring businesses, vessels, and communities remain connected even in remote areas. With solutions tailored for field teams or full enterprises, our broadband-over-satellite services provide low latency, always-on connectivity with robust network management.",
      },
      {
        heading: "IoT Device & Connectivity Management",
        content:
          "Our IoT solutions enable secure onboarding, supervision, and command of connected devices at scale. We integrate satellite and cellular links to support business equipment, sensors, and devices in almost any global region.",
      },
      {
        heading: "IoT Data Integration & Analytics",
        content:
          "Our platforms provide a unified interface for capturing, transmitting, and analyzing IoT data across global networks. Our network and cloud integrations enable real-time data correlation, intelligence, and smart decision-making.",
      },
      {
        heading: "IoT Asset Tracking & Remote Monitoring",
        content:
          "From remote field assets to critical equipment and critical infrastructure, our IoT tracking and monitoring services provide real-time visibility and operational efficiency. With satellite integration, we ensure assets remain visible and secure, even in the most challenging areas.",
      },
    ],
  },
  {
    key: "network",
    title: "Network Services",
    whyChoose: {
      heading: "Why Choose Our Network Services",
      points: [
        "Carrier-grade fiber and ethernet backbone.",
        "Secure, scalable WAN and hybrid solutions.",
        "Flexible options for private networks and DIA.",
        "IP transit and peering with global reach.",
        "24x7 network monitoring with guaranteed SLAs.",
      ],
      image: "/network.png", // Replace with actual image path if different
    },
    sections: [
      {
        heading: "Network Services",
        content:
          "At Video Vision Media, we provide carrier-grade network solutions that enable broadcasters, between operators, enterprises and governments to move content and data with speed, security, and reliability. Our managed services ensure end-to-end performance—from the first mile, to the last.",
      },
      {
        heading: "Managed L1/L2 Services",
        content:
          "We deliver high-capacity fiber, wavelength, and ethernet services, managed end-to-end for guaranteed quality of service. Our Layer 1/Layer 2 connectivity ensures low latency and high reliability, making it ideal for media contribution, data transport, and enterprise applications.",
      },
      {
        heading: "Managed WAN / Hybrid Services",
        content:
          "We design and operate SD-WAN and hybrid networks, combining MPLS, SD WAN, and IP infrastructure for flexible and secure connectivity. Our solutions give enterprises secure, optimized performance across their cloud, data centers, and remote sites.",
      },
      {
        heading: "Private Network or Internet Services",
        content:
          "We provide both private network connectivity and dedicated internet access (DIA). Our private networks offer secure, closed circuits while our internet services guarantee high-capacity bandwidth and global reach—allowing clients to choose what fits best.",
      },
      {
        heading: "IP Transit & Peering Services",
        content:
          "Our IP transit service provides direct access to Tier-1 global carriers, while our peering solutions reduce latency and optimize routing through strategic exchange points. This ensures the fastest, resilient delivery for broadcasters, enterprises, and service providers.",
      },
      {
        heading: "Remote Production",
        content:
          "We empower broadcasters and event organizers to produce live content remotely, reducing on-site costs while maintaining quality, with managed network solutions. Our solutions connect remote sites, studios, and venues for even the most demanding live productions.",
      },
    ],
  },
  {
    key: "asst-mgmt",
    title: "Asset Management",
    whyChoose: {
      heading: "Why Choose Our Asset Mgmt Services",
      points: [
        "Carrier-grade security and redundancy.",
        "Scalable storage optimized for media workflows.",
        "Integrated ingest, transcoding, and metadata management.",
        "Seamless access, tracking, and conditional management.",
        "Protects both content integrity and monetization rights.",
      ],
      image: "/asset.png", // Replace with actual image path if different
    },
    sections: [
      {
        heading: "Asset Management",
        content:
          "At Video Vision Media, we understand that media is more than data—it's valuable intellectual property. Our asset management services provide secure, efficient, and scalable solutions to store, protect, and prepare your content for distribution across multiple platforms.",
      },
      {
        heading: "Media Storage Services",
        content:
          "We provide scalable storage and archiving solutions for media assets, enabling instant access while ensuring long-term security. Our tiered storage schemes deliver cost efficiency with high-speed retrieval, keeping your content safe and accessible.",
      },
      {
        heading: "Content CDN and Security Services",
        content:
          "We offer advanced content distribution and secure content delivery networks (CDNs) optimized for broadcast and OTT. With integrated security, your content is protected from piracy, unauthorized access, and downtime.",
      },
      {
        heading: "Signal Encryption & Conditional Access",
        content:
          "We safeguard live and on-demand content with end-to-end encryption and conditional access systems (CAS). Our solutions ensure only authorized viewers can access premium programming, protecting both content rights and revenue streams.",
      },
      {
        heading: "Media Ingest & Transcoding",
        content:
          "We support multi-format ingest and transcoding services, converting assets into broadcast, OTT, and digital-ready workflows. Our workflows include adaptive bitrate (ABR) encoding, metadata tagging, and quality control to ensure seamless delivery.",
      },
      {
        heading: "Digital Rights Management (DRM)",
        content:
          "We integrate studio-grade DRM solutions that secure premium content across OTT and multi-device environments. Our DRM services support Widevine, PlayReady, and FairPlay, enabling content owners to monetize effectively while protecting licensing agreements.",
      },
    ],
  },
  {
    key: "teleport",
    title: "Teleport Services",
    whyChoose: {
      heading: "Why Choose Our Teleport Services",
      points: [
        "Carrier-grade security and redundancy.",
        "Scalable storage optimized for media workflows.",
        "Integrated uplink/downlink, DRM, and conditional access.",
        "Seamless ingest, transcoding, and metadata management.",
        "Protects both content integrity and monetization (rights).",
      ],
      image: "/teleport.png", // Replace with actual image path if different
    },
    sections: [
      {
        heading: "Teleport Services",
        content:
          "At Video Vision Media, our world-class teleport infrastructure underpins everything we do. With robust uplink, downlink, turnaround, and hosting capabilities, we provide broadcasters, enterprises, and governments with secure, reliable, and globally connected satellite services.",
      },
      {
        heading: "Uplink & Downlink Services",
        content:
          "We offer high-quality uplink and downlink solutions across multiple satellites and orbital positions. Our services guarantee maximum signal availability, redundancy, and quality, making us the trusted partner for broadcasters and service providers worldwide.",
      },
      {
        heading: "Turnaround Services",
        content:
          "Our teleport delivers signal-based services, enabling content to be received in one region, processed, and re-transmitted for distribution anywhere. With multi-band and multi-orbit capabilities, we assure seamless international and domestic workflows.",
      },
      {
        heading: "Earth Station Hosting",
        content:
          "We provide antenna hosting and RF services at our teleport facilities. Clients benefit from secure, monitored environments with full access to power, connectivity, and infrastructure—reducing cost and complexity while maximizing reliability.",
      },
      {
        heading: "VSAT Hub Platforms",
        content:
          "We operate hub-carrier-grade VSAT platforms, offering enterprise, ISP, and governments flexible access to satellite and value-added services. From remote connectivity to enterprise networks, we deliver scalable VSAT solutions for any application.",
      },
      {
        heading: "Disaster Recovery",
        content:
          "Our teleports offer guaranteed backup capacity and failover solutions to ensure business continuity. In the event of network outages or disasters, our teleport-based recovery services safeguard mission-critical broadcasts and communications.",
      },
    ],
  },
];

export default servicesData;
